<template>
  <div>
    <vx-card>
      <div>
        <div class="flex justify-between items-center">
          <p style="font-size: 18px; font-weight: 700">{{ label }}</p>

          <FieldWriteButtonGroup
            :useCopy="isEditable && !!fieldId"
            :useDelete="isEditable && !!fieldId"
            :useSave="isEditable"
            @onClickCopy="onClickCopy"
            @onClickExcel="onClickDownloadExcel"
            @onClickDelete="onClickDelete"
            @onClickMoveList="onClickMoveList"
            @onClickSave="onClickSave"
          />
        </div>

        <!-- 기본정보 -->
        <div class="mt-28px">
          <h5 class="mb-4"><i class="dot"></i> 기본정보</h5>
          <div class="writeGridContainer">
            <div>
              <div>관리주체</div>
              <ml-input v-model="form.management_entity" :readonly="readonly" />
            </div>
            <div>
              <div>소유자</div>
              <ml-input v-model="form.owner" :readonly="readonly" />
            </div>
            <div>
              <div>전화번호</div>
              <ml-input v-model="form.phoneNumber" :readonly="readonly" placeholder="예) 055-123-4567" />
            </div>
            <div>
              <div>보관자</div>
              <ml-input v-model="form.custodian" :readonly="readonly" />
            </div>
            <div>
              <div>관리방법</div>
              <vs-select autocomplete v-model="form.관리방법">
                <vs-select-item text="직접관리" value="직접관리" />
                <vs-select-item text="위탁관리" value="위탁관리" />
              </vs-select>
            </div>
            <div>
              <div>소관부서</div>
              <ml-input v-model="form.소관부서" :readonly="readonly" />
            </div>
            <div>
              <div>담당팀</div>
              <ml-input v-model="form.담당팀" :readonly="readonly" />
            </div>
            <div>
              <div>담당주무관</div>
              <ml-input v-model="form.담당주무관" :readonly="readonly" />
            </div>
          </div>
        </div>
      </div>

      <!-- 시설물 정보 -->
      <mass-feeding-facility-write-body :form="form" :label="label" :readonly="readonly" />

      <!-- 관리 부서 및 업체 등록 -->
      <company-add-module
        title="관리 부서 및 업체 등록"
        :tableColumns="[
          { head: '구분', key: 'com_type' },
          { head: '부서(업체)명', key: 'com_name' },
          { head: '연락처', key: 'phone' },
        ]"
        :isSimple="true"
        :readonly="readonly"
        v-model="companyList"
        @remove="removeCompany"
      />

      <!-- 전경사진 -->
      <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" section-title="전경사진" placeholder="전경사진" :readonly="readonly" />

      <file-upload-module v-model="fileList" class="mt-28px" :readonly="readonly" target="field" />
      <FieldWriteButtonGroup
        :useCopy="isEditable && !!fieldId"
        :useDelete="isEditable && !!fieldId"
        :useSave="isEditable"
        @onClickCopy="onClickCopy"
        @onClickExcel="onClickDownloadExcel"
        @onClickDelete="onClickDelete"
        @onClickMoveList="onClickMoveList"
        @onClickSave="onClickSave"
      />
    </vx-card>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import CompanyAddModule from "@/views/_BS/components/CompanyAddModule";
import DateSelector from "@/components/selector/DateSelector";
import DateSelectorRang from "@/components/selector/DateSelectorRang";
import SignField from "@/components/SignField.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import moment from "moment";
import ExcelJS from "exceljs";
import config from "../../../../../public/config";
import MassFeedingFacilityWriteBody from "@/views/fields/single-page/mass_feeding_facility/MassFeedingFacilityWriteBody.vue";
import FieldWriteButtonGroup from "@/views/fields/components/FieldWriteButtonGroup.vue";

export default {
  name: "MassFeedingFacilityWrite",
  components: {
    MassFeedingFacilityWriteBody,
    FileUploadModule,
    CompanyAddModule,
    DateSelector,
    DateSelectorRang,
    SignField,
    PhotoUploadGridModule,
    FieldWriteButtonGroup,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      form: {
        phoneNumber: "",
        custodian: "",
        관리방법: "직접관리",
        소관부서: "",
        담당팀: "",
        담당주무관: "",

        실질적성격: 0,

        식수인원_조식인원: 0,
        식수인원_중식인원: 0,
        식수인원_석식인원: 0,
        식수인원_일평균_식수인원: 0,

        facilityNumber: "",
        managementNumber: "",
        facilityName: "",
        routeDivision: "",
        routeDetail: "",

        facility_category_id: "",
        cat1: "",
        cat2: "",
        cat3: "",
        classification: "",

        socEvaluationTarget: "",
        address: "",
        management_entity: "",
        management_type: "",
        owner: "",
        ownerType: "",
        businessPlanApprovalDate: "",
        completionDate: "",
        defectLiabilityExpirationDate1: "",
        detailedSpecifications: "",
        safetyInspectionAndDiagnosisHistory: "",
        repairAndReinforcementHistory: "",
        accessibleVentCover: "",
        designPeriod: { sDate: "", eDate: "" },
        designer: "",
        defectLiabilityExpirationDate2: "",
        constructionPeriod: { sDate: "", eDate: "" },
        contractor: "",
        totalConstructionCost: "",
        seismicDesignTarget: "",
        seismicDesignApplication: "",
        seismicDesignStandard: "",
        seismicPerformanceEvaluation: "",
        seismicReinforcement: "",
        young21Target: "",
        auditPeriod: { sDate: "", eDate: "" },
        auditor: "",
        projectOwner: "",
        constructionName: "",
        defectLiabilityExpirationDate: "",
        constructionSupervisor: "",
        creationDate: moment().format("YYYY-MM-DD"),
        author: this.$store.state.auth.userInfo ? this.$store.state.auth.userInfo.name : "",
        signature: "",
        lastModifiedDate: "",
        lastModifiedBy: "",
        remarks: "",

        // 상세제원(청사)
        주용도: "",
        세대수_주택: "",
        층별용도: "",
        기타용도: "",
        층수_지상: "",
        층수_옥탑: "",
        층수_지하: "",
        층수_최고높이: "",
        최고층고_높이: "",
        최고층고_해당층: "",
        구조형식: "",
        지정형태: "",
        기초형식: "",
        // detail
        기초밑면_깊이: "",
        대지면적: "",
        건축면적: "",
        건축_연면적: "",
        건폐율: "",
        용적율: "",
        설계지하수위: "",
        콘크리트_설계강도: "",
        철근강도: "",
        철골강도: "",
        방수공법_지붕층: "",
        방수공법_지하층: "",
        // 주차
        주차면적: "",
        옥내주차면적: "",
        옥외주차면적: "",
        주차대수: "",
        옥내주차대수: "",
        옥외주차대수: "",
        일시최대_사용인원: "",
        일일_사용인원: "",
        // 설비
        환기_공조_방식: "",
        기계식일경우_배기닥트유무: "",
        물탱크_위치: "",
        변전실_위치: "",
        유류저장_시설위치: "",
        오수정화_시설위치: "",
        승객용_승강기대수: "",
        화물용_승강기대수: "",
        비상용_승강기대수: "",

        중앙냉방_냉방유무: "",
        중앙냉방_냉방열원: "",
        중앙난방_난방유무: "",
        중앙난방_난방열원: "",
        전기인입용량: "",

        정화조_형식: "",
        건물유지관리시스템: "",
        유지관리_부대시설: "",
        승강기_운영방식: "",

        otherSpecifications: "",

        companyList: [],
        photoList: [],
      },

      companyList: [],
      userList: [],
      joinUsers: [],
      fileList: [],
      categoryInfo: {
        facility_category_id: 0,
        cat1: "",
        cat2: "",
        cat3: "",
        classification: "",
      },
    };
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    fieldId() {
      return this.$route.params.fieldId;
    },
    myInfo() {
      return this.$store.state.auth.userInfo;
    },
    isAdmin() {
      let isAdmin = false;
      const myInfo = this.$store.state.auth.userInfo;
      isAdmin = isAdmin || parseInt(myInfo.is_superuser) > 0;
      return isAdmin;
    },
    /**
     * 현재 사용자가 프로젝트 관리자인지 확인합니다.
     * 프로젝트 관리자는 사업장을 등록/수정/삭제할 수 있습니다.
     * @returns {boolean}
     */
    isProjectManager() {
      const memberInfo = this.$store.state.member.memberInfo;
      if (memberInfo) {
        if (memberInfo.is_superuser) {
          return true;
        }

        const projects = memberInfo.projects;
        if (projects && projects.length > 0) {
          for (const project of projects) {
            if (`${project.id}` === `${this.projectId}`) {
              return project.pivot.is_manager;
            }
          }
        }
      }
      return false;
    },
    /**
     * 사업장을 프로젝트 관리자만 수정할 수 있는지 확인합니다.
     * @returns {boolean}
     */
    isFieldEditByManagerOnly() {
      const projectInfo = this.$store.state.project.projectInfo;

      return !!projectInfo.field_edit_by_manager_only;
    },
    isEditable() {
      if (this.isFieldEditByManagerOnly) {
        return this.isProjectManager;
      }
      return true;
    },
    readonly() {
      return !this.isEditable;
    },
    excelLink() {
      return `${config.BASE_API_URL}/storage/app/media/%EC%8B%9C%EC%84%A4%EB%AC%BC%EA%B4%80%EB%A6%AC%EB%8C%80%EC%9E%A5_%EA%B1%B4%EC%B6%95%EB%AC%BC.xls`;
    },
  },
  watch: {
    async companyList() {
      await this.initMembers();
    },
    // form.식수인원_조식인원 감시
    "form.식수인원_조식인원"() {
      this.식수인원_업데이트();
    },
    // form.식수인원_중식인원 감시
    "form.식수인원_중식인원"() {
      this.식수인원_업데이트();
    },
    // form.식수인원_석식인원 감시
    "form.식수인원_석식인원"() {
      this.식수인원_업데이트();
    },
    "form.식수인원_일평균_식수인원"() {
      this.식수인원_업데이트();
    },
  },
  async created() {
    await this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
    await this.$store.dispatch("project/LOAD_PROJECT", { project_id: this.projectId });
  },
  async mounted() {
    if (this.fieldId) {
      await this.loadField();
    } else {
      this.form.담당팀 = (this.$store.state.auth.userInfo && this.$store.state.auth.userInfo.section) || "";
    }
  },
  methods: {
    식수인원_업데이트() {
      // 조식, 중식, 석식 인원을 정수로 변환하여 평균 값을 소수점 2째자리까지 계산하여 저장합니다.
      const 조식인원 = parseInt(this.form.식수인원_조식인원);
      const 중식인원 = parseInt(this.form.식수인원_중식인원);
      const 석식인원 = parseInt(this.form.식수인원_석식인원);
      const 평균인원 = (조식인원 + 중식인원 + 석식인원) / 3;
      this.form.식수인원_일평균_식수인원 = 평균인원.toFixed(2);
    },
    async loadField() {
      const fieldId = this.fieldId;
      await this.$store.dispatch("project/LOAD_FIELD", { fieldId });
      const info = JSON.parse(JSON.stringify(this.$store.state.project.fieldInfo));

      this.joinUsers = info.users;
      this.form = { ...this.form, ...info, ...JSON.parse(info.meta) };

      if (info.facility_category) {
        this.form.facility_category_id = info.facility_category.id;
        this.form.cat1 = info.facility_category.cat1;
        this.form.cat2 = info.facility_category.cat2;
        this.form.cat3 = info.facility_category.cat3;
        this.form.classification = info.facility_category.classification;

        this.categoryInfo = {
          facility_category_id: info.facility_category.id,
          cat1: info.facility_category.cat1,
          cat2: info.facility_category.cat2,
          cat3: info.facility_category.cat3,
          classification: info.facility_category.classification,
        };
      }

      if (this.form.companies && info.companies.length > 0) {
        const companies = [];
        for (const company of info.companies) {
          companies.push(company);
        }
        this.companyList = companies;

        await this.initMembers();
      }
      this.form.fileList = info.attachments || [];

      // this.form.photoList 항목이 2개보다 적을 경우, 빈 항목을 추가한다.
      if (this.form.photoList.length < 2) {
        for (let i = this.form.photoList.length; i < 2; i++) {
          this.form.photoList.push({ id: "", url: "" });
        }
      }

      // this.form.photoList 항목이 2개보다 적을 경우, 빈 항목을 추가한다.
      if (this.form.photoList.length < 2) {
        for (let i = this.form.photoList.length; i < 2; i++) {
          this.form.photoList.push({ id: "", url: "" });
        }
      }

      if (this.form.fileList) {
        this.fileList = this.form.fileList;
      }
    },

    async initMembers() {
      const joinUsers = this.joinUsers;
      const members = [];
      for (const company of this.companyList) {
        members.push(...(await this.loadMember(company.id)));
      }

      for (const member of members) {
        let join_project = false;
        for (const user of joinUsers) {
          if (user.id === member.id) {
            join_project = true;
            break;
          }
        }
        member.join_project = join_project;
      }

      this.userList = members;
    },

    async loadMember(company_id) {
      const page = 1;
      const perPage = 100;
      await this.$store.dispatch("company/LOAD_MEMBER_LIST", { page, perPage, company_id });
      return JSON.parse(JSON.stringify(this.$store.state.company.memberList));
    },
    removeCompany(company) {
      let i = 0;
      for (i = 0; i < this.joinUsers.length; i++) {
        const usr = this.joinUsers[i];
        if (usr.company_id === company.id) {
          this.joinUsers.splice(i, 1);
          i--;
        }
      }
    },

    customAlert(msg, title) {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: title ? title : "오류가 발생했습니다",
          message: msg,
        },
      });
      window.dispatchEvent(customAlert);
    },

    onClickSave(isCopy) {
      // 필수 : facilityName,
      if (!this.form.facilityName) {
        this.customAlert("시설물명을 입력해주세요.");
        return;
      }
      if (this.form.phoneNumber && !/^[0-9+()\-\s]+$/.test(this.form.phoneNumber)) {
        this.customAlert("전화번호는 숫자와 하이픈(-)만 입력할 수 있습니다.");
        return;
      }

      const option = {
        project_id: this.projectId, // 프로젝트 ID
        field_name: this.form.facilityName, // 현장(시설물, 사업장) 이름
        contract_code: this.form.facilityNumber, // 계약번호
        address: this.form.address, // 주소
        phone: this.form.phoneNumber, // 대표번호
        be_completed_at: this.form.completionDate, // 준공일
        deposit_amount: this.form.totalConstructionCost, // 총공사비
        facility_category_id: this.form.cat4 || this.form.facility_category_id, // Category
        uploads: this.fileList.map((file) => file.id), // 파일
      };

      const company_ids = [];
      for (const com of this.companyList) {
        company_ids.push(com.id);
      }
      const user_ids = [];
      if (this.joinUsers.length > 0) {
        for (const user of this.joinUsers) {
          user_ids.push(user.id);
        }
      }
      option.company_ids = company_ids;
      option.user_ids = user_ids;

      if (isCopy) {
        option.meta = {
          ...this.form,
          creationDate: moment().format("YYYY-MM-DD"),
          author: this.myInfo.name,
          lastModifiedDate: moment().format("YYYY-MM-DD"),
          lastModifiedBy: this.myInfo.name,
        };
        this.$emit("copy", option);
      } else {
        // Meta
        option.meta = { ...this.form, lastModifiedDate: moment().format("YYYY-MM-DD"), lastModifiedBy: this.myInfo.name };

        this.$emit("save", option);
      }
    },
    onClickCopy() {
      this.onClickSave(true);
    },
    onClickDelete() {
      this.$emit("delete", this.fieldId);
    },
    onClickMoveList() {
      this.$emit("moveList");
    },
    async onClickDownloadExcel() {
      // 엑셀 파일 가져오기
      // 파일은 public/fms/ 경로에 저장되어 있다.
      const response = await fetch("/fms/시설물관리대장_건축물.xlsx");
      const arrayBuffer = await response.arrayBuffer();

      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(arrayBuffer);

      // 첫번째 시트의 이름 가져오기
      const worksheet = workbook.worksheets[0];

      // 시트에 데이터 입력하기
      this.applyDataToSheet(worksheet);

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

      let fileName = "";
      if (this.form.facilityName) {
        if (this.form.facilityNumber) {
          fileName = `시설물관리대장_${this.form.facilityName}_${this.form.facilityNumber}`;
        } else {
          fileName = `시설물관리대장_${this.form.facilityName}`;
        }
      } else if (this.form.facilityNumber) {
        fileName = `시설물관리대장_${this.form.facilityNumber}`;
      } else {
        fileName = `시설물관리대장`;
      }
      fileName += ".xlsx";

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    },
    applyDataToSheet(worksheet) {
      const cellMatchInfo = {
        facilityNumber: ["X4", "B20"], // 시설물번호
        managementNumber: ["X5", "J20"], // 관리번호
        facilityName: ["X6", "Q20", "B41"], // 시설물명
        management_entity: ["W13", "T22"], // 관리주체
        owner: ["W14"], // 소유자
        custodian: ["W15"], // 보관자
        routeDivision: ["Z20"], // 노선-구분
        routeDetail: ["AE20"], // 노선-세부노선
        cat1: ["AS20"], // 시설물구분
        cat3: ["AI20"], // 시설물종류
        classification: ["AO20"], // 시설물종별
        socEvaluationTarget: ["AZ20"], // SOC성능평가대상
        address: ["B22"], // 주소
        businessPlanApprovalDate: ["B27"], // 사업계획승인일
        completionDate: ["G27"], // 준공일
        defectLiabilityExpirationDate1: ["P27"], // 하자보수보증종료일
        detailedSpecifications: ["V27"], // 상세제원
        safetyInspectionAndDiagnosisHistory: ["Y27"], // 안전점검진단이력
        repairAndReinforcementHistory: ["AF27"], // 보수보강이력
        accessibleVentCover: ["AK27"], // 통풍구방법
        designer: ["R29"], // 설계자
        contractor: ["AJ29"], // 시공자
        totalConstructionCost: ["AV29"], // 총공사비
        seismicDesignTarget: ["E31"], // 지진설계대상
        seismicDesignApplication: ["R31"], // 지진설계적용
        seismicDesignStandard: ["AA31"], // 지진설계기준
        seismicPerformanceEvaluation: ["AJ31"], // 지진성능평가
        seismicReinforcement: ["AV31"], // 지진보강
        young21Target: ["B33"], // 영21조대상
        auditor: ["R33"], // 감리자
        projectOwner: ["AA33"], // 사업주체
        constructionName: ["AJ33"], // 공사명
        constructionSupervisor: ["AV33"], // 공사감독
        creationDate: ["B36"], // 작성일
        lastModifiedDate: ["AB36"], // 최종 수정일
        lastModifiedBy: ["AP36"], // 최종 수정자
        remarks: ["D37"], // 비고

        // 상세제원
        주용도: ["K41"], // 주용도
        세대수_주택: ["U41"], // 세대수(주택)
        층별용도: ["AD41"], // 층별용도
        기타용도: ["AM41"], // 기타용도
        층수_지상: ["B44"], // 층수(지상)
        층수_옥탑: ["K44"], // 층수(옥탑)
        층수_지하: ["U44"], // 층수(지하)
        층수_최고높이: ["AD44"], // 층수(최고높이)
        최고층고_높이: ["AM44"], // 최고층고(높이)
        최고층고_해당층: ["AX44"], // 최고층고(해당층)
        구조형식: ["B46"], // 구조형식
        지정형태: ["U46"], // 지정형태
        기초형식: ["AM46"], // 기초형식
        기초밑면_깊이: ["B48"], // 기초밑면(깊이)
        대지면적: ["K48"], // 대지면적
        건축면적: ["U48"], // 건축면적
        건축_연면적: ["AD48"], // 건축(연면적)
        건폐율: ["AM48"], // 건폐율
        용적율: ["AX48"], // 용적율

        설계지하수위: ["B51"], // 설계지하수위
        콘크리트_설계강도: ["K51"], // 콘크리트(설계강도)
        철근강도: ["U51"], // 철근강도
        철골강도: ["AD51"], // 철골강도
        방수공법_지붕층: ["AM51"], // 방수공법(지붕층)
        방수공법_지하층: ["AX51"], // 방수공법(지하층)

        // 주차
        주차면적: ["F53"], // 주차면적
        옥내주차면적: ["M53"], // 옥내주차면적
        옥외주차면적: ["S53"], // 옥외주차면적
        주차대수: ["X53"], // 주차대수
        옥내주차대수: ["AD53"], // 옥내주차대수
        옥외주차대수: ["AI53"], // 옥외주차대수
        일시최대_사용인원: ["AN53"], // 일시최대(사용인원)
        일일_사용인원: ["BA53"], // 일일(사용인원)

        // 설비
        환기_공조_방식: ["F56"], // 환기/공조방식
        기계식일경우_배기닥트유무: ["M56"], // 기
        물탱크_위치: ["S56"], // 물탱크위치
        변전실_위치: ["X56"], // 변전실위치
        유류저장_시설위치: ["AD56"], // 유류저장시설위치
        오수정화_시설위치: ["AI56"], // 오수정화시설위치
        승객용_승강기대수: ["AN56"], // 승객용승강기대수
        화물용_승강기대수: ["AT56"], // 화물용승강기대수
        비상용_승강기대수: ["BA56"], // 비상용승강기대수

        중앙냉방_냉방유무: ["F59"], // 중앙냉방(냉방유무)
        중앙냉방_냉방열원: ["M59"], // 중앙냉방(냉방열원)
        중앙난방_난방유무: ["AD59"], // 중앙난방(난방유무)
        중앙난방_난방열원: ["AI59"], // 중앙난방(난방열원)
        전기인입용량: ["BA59"], // 전기인입용량

        정화조_형식: ["F61"], // 정화조(형식)
        건물유지관리시스템: ["S61"], // 건물유지관리시스템
        유지관리_부대시설: ["AD61"], // 유지관리(부대시설)
        승강기_운영방식: ["AN61"], // 승강기(운영방식)

        otherSpecifications: ["M62"], // 기타제원
      };

      for (const key in cellMatchInfo) {
        const cell = cellMatchInfo[key];
        for (const c of cell) {
          worksheet.getCell(c).value = this.form[key] ? this.form[key] : "";
        }
      }

      worksheet.getCell("Y25").value = "";
      worksheet.getCell("AC25").value = "";
      worksheet.getCell("AG25").value = "";
      worksheet.getCell("AI23").value = "";
      if (this.form.management_type === "중앙부처") {
        worksheet.getCell("Y25").value = "V";
      } else if (this.form.management_type === "지자체") {
        worksheet.getCell("AC25").value = "V";
      } else if (this.form.management_type === "(국가/지방)공기업") {
        worksheet.getCell("AG25").value = "V";
      } else if (this.form.management_type === "민간") {
        worksheet.getCell("AI23").value = "V";
      }

      worksheet.getCell("AQ25").value = "";
      worksheet.getCell("AW25").value = "";
      worksheet.getCell("AY25").value = "";
      worksheet.getCell("BB23").value = "";
      if (this.form.ownerType === "중앙부처") {
        worksheet.getCell("AQ25").value = "V";
      } else if (this.form.ownerType === "지자체") {
        worksheet.getCell("AW25").value = "V";
      } else if (this.form.ownerType === "(국가/지방)공기업") {
        worksheet.getCell("AY25").value = "V";
      } else if (this.form.ownerType === "민간") {
        worksheet.getCell("BB23").value = "V";
      }

      // 전화번호 (AH14)
      worksheet.getCell("AH14").value = `전화번호: ${this.form.phoneNumber}`;

      // 첨부자료 목록 (AR27)
      const fileNames = this.fileList.map((file) => file.originalName).join(", ");
      worksheet.getCell("AR27").value = fileNames;

      // 설계기간 (B29)
      worksheet.getCell("B29").value = `${this.form.designPeriod.sDate} ~ ${this.form.designPeriod.eDate}`;

      // 공시기간 (AA29)
      worksheet.getCell("AA29").value = `${this.form.constructionPeriod.sDate} ~ ${this.form.constructionPeriod.eDate}`;

      // 감리기간 (E33)
      worksheet.getCell("E33").value = `${this.form.auditPeriod.sDate} ~ ${this.form.auditPeriod.eDate}`;

      // 작성자 (N36)
      worksheet.getCell("N36").value = `${this.form.author}  (인)`;
    },
  },
};
</script>

<style scoped lang="scss">
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    font-size: 14px;
    font-weight: 500;
    text-align: center;

    border: 1px solid #cdcdcd;
    padding: 5px;
  }

  th {
    background: #f9f9f9;
    padding: 10px 4px;
  }
}
</style>
<style scoped lang="scss">
.table-list {
  .action-button {
    margin-left: auto;
  }
}

.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
  padding-left: 12px;

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    background: #7e72f2;
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -8px;
    border-radius: 100%;
  }
}

.title-n {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.size-search {
  width: 200px;
}

.input-se {
  width: 100%;

  &::v-deep .start-end-title {
    width: 114px;
    font-weight: 500;
    font-size: 14px;
    justify-content: flex-start;
  }

  &::v-deep .mr-2 {
    flex: 1;
    margin-right: 10px !important;
  }

  &::v-deep .mr-2 + .mr-2 {
    margin-right: 0 !important;

    &::before {
      content: "~";
      margin-right: 10px;
    }
  }

  &::v-deep .inline-block {
    width: 100% !important;
  }
}

.vs-table-primary .is-selected {
  background: rgba(126, 114, 242, 0.6) !important;
  color: white;
}

.search-item {
  width: 100% !important;
  margin: 0 !important;

  &::v-deep > div:first-child {
    width: 114px !important;
    font-weight: 500;
    font-size: 14px;
  }

  &::v-deep > div:last-child {
    flex: 1 !important;

    .con-select {
      width: 100%;
    }
  }
}

.upload-img {
  width: 100%;
  height: 318px !important;
  margin-top: 22px;
}
</style>

<style lang="scss">
.none-card {
  box-shadow: none;
  border-radius: 0;
  display: inline-block;

  .vx-card__body {
    padding: 0 !important;
  }
}

span.up {
  color: #28c76f;
}

span.down {
  color: #ea5455;
}

.vs-table--tbody-table tr:nth-child(2n) {
  background-color: #f9f9f9;
}
</style>
